import React from 'react';
import { CombinedImage } from '@ynap/image';
import HtmlVideoPlayer from '@ynap/video';
import ViewportObserver from '@ynap/viewport-observer';

interface Image {
    id: string;
    url: string;
    alt: string;
    srcSet?: string;
}

interface Thumbnail {
    alt: string;
    url: string;
}

interface Video {
    url: string;
    thumbnail?: Thumbnail;
}

interface GalleryContent {
    images: Image[];
    videos: Video[];
    /* eslint-disable no-unused-vars */
    setIsZoomModalVisible: (visible: boolean) => void;
    setSelectedZoomImageIndex: (index: number) => void;
    bem: (className: string) => string | undefined;
}

export const buildGalleryContent = ({ images, videos, setIsZoomModalVisible, setSelectedZoomImageIndex, bem }: GalleryContent) => {
    const handleClick = (index: number) => {
        setIsZoomModalVisible(true);
        setSelectedZoomImageIndex(index + 1);
    };

    const assertedImages = images.map((image, index) => {
        const { alt, id, srcSet, url } = image;

        return {
            video: false,
            ...image,
            component: (
                <div onClick={() => handleClick(index)} className={bem('imageContainer')} key={id}>
                    <CombinedImage
                        key={id}
                        src={url}
                        alt={alt}
                        primarySrcset={srcSet}
                        displaySrc
                        yOffset="100%"
                        withIntersectionObserver={index > 1} //remove intersection observer for first image
                        cover
                    />
                </div>
            ),
        };
    });

    const assertedVideos = videos.map((video) => {
        return {
            video: true,
            ...video,
            component: (
                <ViewportObserver threshold={[0.5]} keepObserving key={`gallery-video-observer-${video.url}`}>
                    {(intersected: boolean) => {
                        return <HtmlVideoPlayer video={video} key={video.url} intersected={intersected} className={bem('video')} />;
                    }}
                </ViewportObserver>
            ),
        };
    });

    if (!assertedVideos.length) return assertedImages;

    return [...assertedImages, assertedVideos[0]];
};
